export default "__VITE_ASSET__69011863__"